var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.99L27.53 28H12.47L20 14.99ZM20 11L9 30H31L20 11Z",
    fill: "#F79009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25H19V27H21V25Z",
    fill: "#F79009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19H19V24H21V19Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.49e1e5e2d2c2d9e5b554840714fad756.svg";
export { ForwardRef as ReactComponent };